module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-notice-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/company_notice"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/company_notice_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Company Notice Detail')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice Detail')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group line-break"
  }, [_c('span', [_vm._v(_vm._s(_vm.companyNotice.title))])])])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group line-break"
  }, [_c('span', [_vm._v(_vm._s(_vm.companyNotice.detail))])])])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.startDateFormat))])])])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.endDateFormat))])])])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("メール配信有無")]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', [_vm._v(_vm._s(_vm.isSendMailFormat))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("通達タイトル")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("通達詳細")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("通達表示開始日")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("通知期間終了日")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10a84800!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/company-notice-detail.pug
// module id = 759
// module chunks = 1